window.global = window.global || window;
window.setImmediate = window.setImmediate || window.setTimeout;
